import React from 'react';
import {ReactComponent as Icon} from "./FalcoIcon.svg";

const FalcoIcon = (props) => {
  return <Icon {...props} />;
};

export default FalcoIcon;